const initialStatePersonnel = {
  personnel: [],
  update_personnel: false,
};

export default initialStatePersonnel;